import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as teams from '@webapp/sdk/teams';
import { Actions } from '../../actions';
import {
  RemoveTeamMember,
  RemoveTeamMemberError,
  RemoveTeamMemberSuccess,
} from '../action-creators';
import { REMOVE_TEAM_MEMBER } from '../actions';
import AppState from '../../state';

export const removeTeamMemberEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, RemoveTeamMember>(REMOVE_TEAM_MEMBER),
    withLatestFrom(state$),
    mergeMap(async ([action, _]) => {
      try {
        await teams.remove(action.member.id, action.member.labelId);

        return new RemoveTeamMemberSuccess(action.member);
      } catch (err) {
        return new RemoveTeamMemberError(err.message);
      }
    })
  );
